<template>
  <div class="reservationTicket">
    <div v-if="loading">
      読み込み中です
    </div>
    <div v-else>
      <img class="logo" :src="logo">
      <div class="top-title">オンライン健康相談予約確認ページ</div>
      <div v-if="returnData != null">
        <div class="title">予約情報</div>
        <div class="description">{{ date_string(returnData.reserve.start, returnData.reserve.end) }}</div>
        <div class="title">担当医師名</div>
        <div class="description">{{ returnData.reserve.doctor_name }}</div>
        <div class="title">相談者氏名</div>
        <div class="description">{{ returnData.reserve.name }}</div>
        <div class="title">相談の分類</div>
        <div v-for="data in returnData.reserve.consultation_categories" v-bind:key="data.name"  class="description">
          {{consultation_categories_name(data)}}
        </div>
        <div class="center top-padding">
          <router-link to="term" class="link" target="_blank" @click.native="open_term">利用規約を表示</router-link>
        </div>
        <div class="center">
          <input type="checkbox" id="check" v-model="isDisable" v-bind:disabled="!isOpen">
          <label for="check">利用規約に同意して利用します</label>
        </div>
        <div class="cancel-hint">※予約をキャンセルする場合は予約をされた方にキャンセルしてもらうようにしてください</div>
        <div class="cancel-hint">※ “SaveYou” 及び “TONE Care” はフリービット株式会社が弊社社員・社員家族の向けに提供する健康相談サービスです。本資料の情報の社外への提供はご遠慮ください。</div>
        <br>
        <button class="zoom-btn" v-bind:class="{ 'zoom-visble-bun': isDisable}" v-on:click="zoom_start(returnData.reserve.joinUrl)">
          相談通話を開始する
        </button>
        <button class="survey-btn" v-bind:class="{ 'survey-visble-bun': isSurvey}" v-on:click="move_survey()">
          実施後アンケートに回答する
        </button>
        <button class="inquiry-button" v-on:click="move_inquiry()">
          お問い合わせ
        </button>
        <div class="copy-right">
          <small class="copy-right">©2022 FreeBit Co., Ltd. All Rights Reserved.</small>
        </div>
      </div>
      <div v-else class="error">
        <img :src="errorImg" class="error-img">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import errorImg from '../assets/404.png'
import logo from '../assets/logo.png'
import { getAnalytics, logEvent } from 'firebase/analytics'

export default {
  name: 'ReservationTicket',
  data () {
    return {
      analytics: null,
      apiEndpoint: process.env.API_DOMAIN,
      loading: true,
      returnData: null,
      isDisable: false,
      isOpen: false,
      isSurvey: false,
      logo: logo,
      errorImg: errorImg
    }
  },
  mounted () {
    this.apiEndpoint = this.apiEndpoint.replace('company_id', this.$route.query.company_id)
    // ページを開いた際にGA送信
    this.analytics = getAnalytics()
    logEvent(this.analytics, 'site_tonecare_reserve_confirm', {
      'belong_company': this.$route.query.company_id
    })

    axios.post(
      this.apiEndpoint + '/api/medical/getOneReservation',
      {
        'reservationToken': this.$route.query.token,
        'companyId': this.$route.query.company_id
      }
    ).then((response) => {
      if (response.data.status === 200) {
        this.returnData = response.data
        var nowData = moment()
        var startDate = moment(this.returnData.reserve.start).add(5, 'm')
        this.isSurvey = startDate.isAfter(nowData)
      } else {
        // デバッグ用Json(固定値)の導入
        // this.returnData = data
        window.location.href('./')
      }
      this.loading = false
    }).catch((e) => {
      this.loading = false
    })
  },
  comments: {
  },
  methods: {
    consultation_categories_name (consultationCategories) {
      switch (consultationCategories) {
        case 'specific':
          return '・特定の症状に関する相談'
        case 'illness':
          return '・ご自身やご家族の病気に関する相談'
        case 'covid19':
          return '・新型コロナウイルス感染症に関する相談'
        case 'other':
          return '・そのほか健康に関する相談'
      }
    },
    date_string (start, end) {
      return moment(start).format('YYYY/MM/DD HH:mm ~') + moment(end).format('HH:mm')
    },
    zoom_start (url) {
      // Zoomを起動した際GA送信
      logEvent(this.analytics, 'site_tonecare_reserve_exec', {
        'belong_company': this.$route.query.company_id
      })
      if (this.isDisable) {
        window.open(url)
      }
    },
    move_survey () {
      if (this.isSurvey) {
        window.open(this.apiEndpoint + '/medicalSurvey/family?token=' + this.$route.query.token)
      }
    },
    move_inquiry () {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSflCZsVziRn3SfoEmhhYQFL5znxXeoPvPaCGaF1UEvq-FiDaw/viewform?usp=sf_link')
    },
    open_term () {
      this.isOpen = true
    }
  }
}
</script>

<style scoped>
.reservationTicket {
  margin: 16px;
}

.logo {
  display: block;
  margin: 24px auto;
  width: 120px;
  height: auto;
}

.top-title {
  margin-top: 32px;
  margin-bottom: 24px;
  text-align: center;
  font-size: 16pt;
  font-weight: bold;
}

.title {
  font-size: 16px;
}

.description {
  margin-top: 12px;
  margin-bottom: 20px;
  font-size: 20px;
}

.center {
  text-align: center;
  margin-bottom: 16px;
}

.link {
  color: #007AFF;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  text-decoration: none;
}

.top-padding {
  margin-top: 40px;
}

.cancel-hint {
  line-height: 1.3em;
  font-size: 16px;
  color: #707070;
  margin: 8px 0;
}

.error {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
}

.error-img {
  width: 100%;
  vertical-align: middle;
}

.zoom-btn {
  width: 100%;
  padding: 0.6em 1em; /* 塗りの余白 */
  font-size: 1em; /* フォントサイズ */
  color: #FFF; /* テキストカラー */
  background-color: #999999; /* 背景色 */
  cursor: pointer; /* カーソルを指マークに */
  border-radius: 50px; /* 角の丸み */
  border: 0; /* 枠線を消す */
  transition: 0.3s; /* ホバーの変化を滑らかに */
}

.zoom-visble-bun {
  background-color: #49ADF9; /* 背景色 */
}

.survey-btn {
  margin-top: 16px;
  width: 100%;
  padding: 0.6em 1em; /* 塗りの余白 */
  font-size: 1em; /* フォントサイズ */
  color: #999999; /* テキストカラー */
  background-color: transparent; /* 背景色 */
  cursor: pointer; /* カーソルを指マークに */
  border-radius: 50px; /* 角の丸み */
  /* 枠線を消す */
  border: 2px solid #999999;
  transition: 0.3s; /* ホバーの変化を滑らかに */
}

.survey-visble-bun {
  color: #49ADF9; /* テキストカラー */
  background-color: transparent; /* 背景色 */
  border: 2px solid #49ADF9;
}

.inquiry-button {
  margin-top: 32px;
  width: 100%;
  padding: 0.6em 1em; /* 塗りの余白 */
  font-size: 1em; /* フォントサイズ */
  color: #49ADF9; /* テキストカラー */
  background-color: transparent; /* 背景色 */
  cursor: pointer; /* カーソルを指マークに */
  border-radius: 50px; /* 角の丸み */
  /* 枠線を消す */
  border: 2px solid #49ADF9;
  transition: 0.3s; /* ホバーの変化を滑らかに */
}

.copy-right {
  text-align: center;
  font-size: 12pt;
  position: relative;
  top: 50px; left: 0; right: 0;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReservationTicket.vue